export default "__VITE_ASSET__BUVKF$FI__"